import { Injectable } from '@angular/core';
import { ServiceModel } from '../../model/file/model.file';
import { ServicesInputModel as ServiceInputModel } from '../api/models/file';
import { MapperService } from './mapperTemplate.service';

@Injectable()
export class ServicesMapperService extends MapperService<
  ServiceModel,
  ServiceInputModel
> {
  protected map(entity: ServiceModel): ServiceInputModel {
    return {
      id: entity.id,
      idProducto: entity.productId,
      idProveedor: entity.idProveedor,
      idServicio: entity.idServicio,
      idTarifa: entity.idTarifa,
      isArchived: entity.isArchived,
      itineraryID: entity.itineraryID,
      nombreServicio: entity.nombreServicio,
      serviceDay: entity.serviceDay,
      tipoProveedor: entity.tipoProveedor,
      tipoServicio: entity.tipoServicio,
      horaInicio: entity.horaInicio
    };
  }
}

@Injectable()
export class IncidenciasMapperService extends MapperService<any, any> {
  protected map(entity: any): any {
    let incidencia: any = {};
    incidencia = {
      nombreItinerario: entity.nombreItinerario,
      usuario: entity.usuario,
      paxQuantity: entity.paxQuantity,
      estadoItinerario: entity.estadoItinerario,
      dateRange: entity.dateRange,
      diasItinerario: entity.diasItinerario,
      itinerarios: entity.itinerarios,
      listPassenger: entity.listPassenger,
      estadoCambio: entity.estadoCambio,
      createdFile: entity.createdFile,
      dateConfirmed: entity.dateConfirmed,
      dateReconfirmed: entity.dateReconfirmed,
      estadoReconfirmed: entity.estadoReconfirmed,
      totalPriceDolares: entity.totalPriceDolares,
      totalCostoDolares: entity.totalCostoDolares,
      totalUtilidadDolares: entity.totalUtilidadDolares,
      itinerarioDetalladoId: entity.itinerarioDetalladoId,
      clienteId: entity.clienteId,
      nameClient: entity.nameClient,
      archived: entity.archived,
      tipoCambio: entity.tipoCambio,
      lstPaX: entity.lstPaX,
      dueDate: entity.dueDate,
      arrivalDate: entity.arrivalDate,
      operator: entity.operator,
      id: entity.id,
      createdAt: entity.createdAt,
      updatedAt: entity.updatedAt,
      modelName: entity.modelName,
      descripcionEmail: entity.descripcionEmail,
      estadoFile: entity.estadoFile,
      fileName: entity.fileName,
      fileNumber: entity.fileNumber,
      isDeleted: entity.isDeleted
    };
  }
}
